import env from "@/environmentVariables";
import type { ApiObjectType } from "@/models/api";

function toAbsolute(
  relativeOrAbsolute: string | undefined | null,
  base: string = window.location.href,
) {
  if (!relativeOrAbsolute) {
    return null;
  }
  return new URL(relativeOrAbsolute, base).href;
}
function fixEnd(str: string | undefined | null, char: string) {
  if (!str) {
    return null;
  }
  return str.endsWith(char) ? str : str + char;
}
function fixStart(str: string | undefined | null, char: string) {
  if (!str) {
    return null;
  }
  return str.startsWith(char) ? str : char + str;
}

const apiProt = fixEnd(env.VITE_API_PROT, ":") || window.location.protocol;
const apiHost = env.VITE_API_HOST || window.location.hostname;
const apiPort = env.VITE_API_PORT ? `:${env.VITE_API_PORT}` : "";
const apiPath = fixStart(env.VITE_API_PATH, "/") || "/api/v1";  // must have a leading slash!

const apiUrl = ( /* eslint-disable-line prettier/prettier *//* eslint-disable-next-line prettier/prettier */
  toAbsolute(env.VITE_API_URL, `${apiProt}//${apiHost}${apiPort}`)
  ?? `${apiProt}//${apiHost}${apiPort}${apiPath}`
);
const baseUrl = toAbsolute(env.BASE_URL || "/") as string; // BASE_URL can be empty, "./", absolute path, or full url.
// noinspection SpellCheckingInspection
const qrUrl = ( /* eslint-disable-line prettier/prettier *//* eslint-disable-next-line prettier/prettier */
  toAbsolute(env.VITE_QR_URL?.replace("{barcode}", "<barcode>"), baseUrl)?.replace('%3Cbarcode%3E', '<barcode>')
  || `${baseUrl}barcode/<barcode>`
);

export const getApiUrl = (loadFromLocalStorage: boolean = true) => {
  const localStoreUrl = ( /* eslint-disable-line prettier/prettier *//* eslint-disable-next-line prettier/prettier */
    loadFromLocalStorage
    ? localStorage.getItem("apiUrl")
    : null
  );
  return localStoreUrl || apiUrl;
};
/* eslint-disable-next-line prettier/prettier */
export const getQrUrl = (barcode: string) => qrUrl.replace("<barcode>", barcode);
/* eslint-disable-next-line prettier/prettier */
export const getBaseUrl = (full: boolean = true) => full ? baseUrl : new URL(baseUrl).pathname;

console.log("URLs:", {
  baseUrl,
  apiUrl,
  qrUrl,
  parts: { apiProt, apiHost, apiPort, apiPath },
  env,
});

export const OBJECT_TYPE_CONTAINER: ApiObjectType = 1;
export const OBJECT_TYPE_ITEM: ApiObjectType = 2;
